import React from 'react'

import { useMasterBillState } from '../../stores/useMasterBillStore'

import {
  MasterBillStatus,
  MasterBillStatusDisplay
} from '@/types/customs'

const MasterBillStatusBadge: React.FC = () => {
  const { masterBill } = useMasterBillState()
  const billStatus = masterBill?.status || MasterBillStatus.PENDING_CONFIRMATION

  const getStatusColor = (status: MasterBillStatus): string => {
    switch (status) {
      case MasterBillStatus.PENDING_CONFIRMATION:
        return 'bg-blue-100 text-blue-800 border-blue-200'
      case MasterBillStatus.AWAITING_DEVAN:
        return 'bg-yellow-100 text-yellow-800 border-yellow-200'
      case MasterBillStatus.DEVANNING:
        return 'bg-orange-100 text-orange-800 border-orange-200'
      case MasterBillStatus.MOVED_IN:
        return 'bg-purple-100 text-purple-800 border-purple-200'
      case MasterBillStatus.MOVED_OUT_FINAL:
        return 'bg-green-100 text-green-800 border-green-200'
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200'
    }
  }

  const getStatusIcon = (status: MasterBillStatus): string => {
    switch (status) {
      case MasterBillStatus.PENDING_CONFIRMATION:
        return '❓'
      case MasterBillStatus.AWAITING_DEVAN:
        return '📦'
      case MasterBillStatus.DEVANNING:
        return '🔧'
      case MasterBillStatus.MOVED_IN:
        return '🏭'
      case MasterBillStatus.MOVED_OUT_FINAL:
        return '🚚'
      default:
        return '📄'
    }
  }

  return (
    <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusColor(billStatus)}`}>
      <span className="mr-1">{getStatusIcon(billStatus)}</span>
      {MasterBillStatusDisplay[billStatus]}
    </div>
  )
}

export default MasterBillStatusBadge